<div class="graph-wrapper" #divWrapper >
  <ngx-charts-line-chart
    (window:resize)="onResize($event)"
    [view]="view"
    [scheme]="colorScheme"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [timeline]="timeline"
    [results]="multiLines"
    (select)="onSelect($event)"
    [legend]="legend"
    [legendTitle]=null
    [legendPosition]=null>
  </ngx-charts-line-chart>
</div>
